import { Component, Input, OnChanges, ChangeDetectionStrategy } from "@angular/core";
import { ListPickerItem } from "@onsip/web/features/shared/components/pickers/listPicker/list-picker-item";
import { countriesList, Country } from "@onsip/common/interfaces/countries-list";
import { TranslateService } from "@ngx-translate/core";

@Component({
  selector: "onsip-country-list-view",
  templateUrl: "country-list-view.component.html",
  styleUrls: ["../sayso-topic-view.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class CountryListViewComponent implements OnChanges {
  @Input() countries: Array<string> = [];
  countryListItems: Array<ListPickerItem> = [];
  allCountries: Array<ListPickerItem> = [];

  constructor(private translate: TranslateService) {
    this.allCountries = countriesList.map((country: Country) => ({
      name: this.translate.instant(`ONSIP_I18N.COUNTRY_CODE.${country.code}`),
      id: country.code,
      avatarUrl: `resources/img/country_flags/${country.code}.png`
    }));
  }

  ngOnChanges() {
    if (this.allCountries && this.countries) {
      this.countryListItems = this.allCountries.filter((country: ListPickerItem) =>
        this.countries.find((code: string) => code === country.id)
      );
    }
  }
}
